<template>
<div id="app">
  <webGl v-show="this.innerWidth >= 520" v-if="!isMobile"></webGl>
  <div v-if="isMobile || this.innerWidth <= 520" class="mobile">
    <a href="https://www.instagram.com/wideawake.earth/">
    <img :src="img.logo">
    <img style="max-width: 100px" :src="img.logoHantel">
    <div class="coming-soon">
      <img :src="img.comingsoon">
    </div>
</a>
  </div>
  <transition appear name="fade">
    <div v-show="this.innerWidth >= 520" class="transition-delay">

      <div class="coming-soon">
        <img :src="img.comingsoon">
      </div>
      <footer>
        Teaser made by [<a href="https://www.selam-x.com">Selam X</a>] - <a href="https://www.instagram.com/artur.neufeld/">Artur Neufeld</a> with <a href="https://cables.gl">cables</a>
        <!-- we would greatly appreciate if you link cables somewhere on your site! and tell us your website! thanks <3 :) -->
      </footer>
    </div>
  </transition>
</div>
</template>

<script>
import webGl from './components/webGl.vue'

export default {
  name: 'app',
  data() {
    return {
      innerWidth: window.innerWidth,
      img: {
        comingsoon: require('@/assets/comingsoon.png'),
        logo: require('@/assets/wideawake1.png'),
        logoHantel: require('@/assets/logo_typo.png'),
      }
    }
  },
  components: {
    webGl
  },
  created() {
    window.addEventListener('resize', () => this.innerWidth = window.innerWidth)
  },
  computed: {
    isMobile() {
      if (navigator.userAgent.match(/Mobi/)) {
        return true;
      }

      if ('screen' in window && window.screen.width < 520) {
        return true;
      }

      var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
      if (connection && connection.type === 'cellular') {
        return true;
      }

      return false;
    }
  }
}
</script>

<style lang="scss">
.fade-enter-active {
    transition: opacity 1s ease-out;
    transition-delay: 10s;
}
.fade-enter {
    opacity: 0;
}
.fade-enter-to {
    opacity: 1;
}
.transition-delay {
    // opacity: 0;
}
#app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    // text-align: center;
    color: white;

}
.coming-soon {
    position: absolute;
    bottom: 2em;
    margin: 0 auto;
    display: block;
    width: 100%;
    text-align: center;
    img {
        max-width: 320px;
        width: 100%;

    }
}

.mobile {
    margin: 0 auto;
    width: 100%;
    text-align: center;
    img {
        max-width: 320px;
        width: 100%;

    }
}
body,
html {
    height: 100%;
}
body {
    margin: 0;
    background-color: #000;
    color: #fff;
}

canvas {
    display: block;
}

footer {
    position: absolute;
    bottom: 0;
    left: 0;
    box-sizing: border-box;
    width: 100%;
    padding: 20px;
    text-align: right;
    font-size: 8px;
    color: white;
}

footer a,
footer a:active,
footer a:hover {
    color: white;
}
</style>
